import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { SynchronizePaymentTradesPostRequestModel, SynchronizePaymentTradesPostResponseModel } from "@/features/accounts/payment/scraping/services/synchronize-trades-model";

export class SynchronizePaymentTradesApi {
  /**
   * Look明細同期API
   */
  public synchronizePaymentTrades = async (
    param: SynchronizePaymentTradesPostRequestModel
  ): Promise<SynchronizePaymentTradesPostResponseModel> => {
    const path = `/api/paymentaccounts/payments/synchronizetrades`;
    const res = await ApiClient.instance.post<SynchronizePaymentTradesPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
